var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTableMain',{attrs:{"datatable":_vm.table,"on-success":_vm.successAction,"items-action":_vm.tableAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }